import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { EnterpriseOption } from '@app/core/interfaces/enterprise-option';
import { EnterpriseOptionDefinition } from '@app/core/interfaces/enterprise-option-definition';
import { AssignedEnterpriseOption } from '@app/core/interfaces/papic/assigned-enterprise-option';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { EnterpriseOptionsAndAssignedFeatureProfiles } from '@business/enterprise-option/interfaces/enterpriseOptionsAndAssignedFeatureProfiles';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseOptionRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  listDefinitions(): Observable<EnterpriseOptionDefinition[]> {
    return this.utils
      .apiUrl({
        [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.ServiceProvider + '/optionDefinitions',
      })
      .pipe(
        mergeMap((url) => this.http.get<EnterpriseOptionDefinition[]>(url)),
        wrapError('enterprise-option-repository:list-definitions')
      );
  }

  listWithAssignedFeatureProfiles(): Observable<EnterpriseOptionsAndAssignedFeatureProfiles> {
    const pathSuffix = '/option?withFPsAndVirtualUserCount=true';
    const urls = {
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + pathSuffix,
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + pathSuffix,
    };

    return this.utils.apiUrl(urls).pipe(
      mergeMap((url) => this.http.get<EnterpriseOptionsAndAssignedFeatureProfiles>(url)),
      wrapError('enterprise-option-repository:list-with-assigned-feature-profiles')
    );
  }

  recalculateEnterpriseOptionsUsage(): Observable<EnterpriseOption[]> {
    const pathSuffix = '/option/recalculateUsage';
    const urls = {
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + pathSuffix,
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + pathSuffix,
    };
    return this.utils.apiUrl(urls).pipe(
      mergeMap((url) => this.http.get<EnterpriseOption[]>(url)),
      wrapError('enterprise-option-repository:recalculate-enterprise-options-usage')
    );
  }

  updateOptions(updates: AssignedEnterpriseOption[]): Observable<EnterpriseOption[]> {
    return this.utils
      .apiUrl({
        [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + '/option',
      })
      .pipe(
        mergeMap((url) => this.http.put<EnterpriseOption[]>(url, updates)),
        wrapError('enterprise-option-repository:update-options')
      );
  }
}
